
const LANG_SC = 0;
const LANG_TC = 1;
const LANG_EN = 2;
const LANG_JA = 5;

const LANG_LIST = {
    [LANG_SC]: 'zh-cn',
    [LANG_TC]: 'zh-hk',
    [LANG_EN]: 'en-us',
    [LANG_JA]: 'ja'
};

const LANG_NUM_STRING_MAP = {
    [LANG_SC]: 'stringSc',
    [LANG_TC]: 'stringTc',
    [LANG_EN]: 'stringEn',
    [LANG_JA]: 'stringJa'
};

const FEED_TYPE = {
    TEXT: 0,
    TEXT_LINK: 7
};

export default {
    THEME: {
        BLACK: 'black',
        WHITE: 'white'
    },
    CONTENT_TYPE: { // 对应后端枚举
        NEWEST: 1,
        HOT: 3
    },
    LANG: {
        LANG_SC,
        LANG_TC,
        LANG_EN,
        LANG_JA
    },
    LANG_LIST,
    LANG_NUM_STRING_MAP,
    FEED_TYPE
}